import React from 'react';
import { Link } from 'react-router-dom';
import { FaCode, FaLaptopCode, FaDatabase, FaCodeBranch } from 'react-icons/fa';

const Home = () => {
  const technologies = [
    { 
      name: 'HTML', 
      path: '/html', 
      description: 'The standard markup language for creating Web pages',
      icon: <FaCode className="tech-icon" />
    },
    { 
      name: 'CSS', 
      path: '/css', 
      description: 'The language for styling and layout of Web pages',
      icon: <FaLaptopCode className="tech-icon" />
    },
    { 
      name: 'JavaScript', 
      path: '/javascript', 
      description: 'The programming language of the Web',
      icon: <FaCode className="tech-icon" />
    },
    { 
      name: 'Python', 
      path: '/python', 
      description: 'A popular programming language for various applications',
      icon: <FaLaptopCode className="tech-icon" />
    },
    { 
      name: 'MySQL', 
      path: '/mysql', 
      description: 'The world\'s most popular open source database',
      icon: <FaDatabase className="tech-icon" />
    },
    { 
      name: 'Git', 
      path: '/git', 
      description: 'Distributed version control system',
      icon: <FaCodeBranch className="tech-icon" />
    },
  ];

  return (
    <div className="home">
      <section className="hero">
        <div className="hero-content">
          <h1>Learn to Code</h1>
          <p>With the world's largest web developer site.</p>
          <div className="search-box">
            <input 
              type="text" 
              placeholder="Search our tutorials, e.g. HTML" 
              aria-label="Search tutorials"
            />
            <button>Search</button>
          </div>
        </div>
      </section>

      <section className="technologies">
        <h2>Popular Technologies</h2>
        <p className="section-subtitle">Browse our most popular learning paths and start your coding journey today</p>
        <div className="tech-grid">
          {technologies.map((tech, index) => (
            <Link to={tech.path} key={index} className="tech-card">
              <div className="tech-icon-container">
                {tech.icon}
              </div>
              <h3>{tech.name}</h3>
              <p>{tech.description}</p>
              <span className="learn-more">Learn {tech.name} →</span>
            </Link>
          ))}
        </div>
      </section>

      <section className="get-started">
        <div className="get-started-content">
          <h2>Not sure where to begin?</h2>
          <p>No problem! Start with our beginner-friendly <Link to="/html">HTML tutorial</Link> and build your first website today.</p>
          <div className="cta-buttons">
            <Link to="/html" className="btn btn-primary">Start Learning</Link>
            <a href="#" className="btn btn-outline">Watch Video Tutorials</a>
          </div>
        </div>
      </section>

      <section className="features">
        <div className="feature">
          <div className="feature-icon">📚</div>
          <h3>Comprehensive Tutorials</h3>
          <p>Step-by-step guides to learn programming at your own pace.</p>
        </div>
        <div className="feature">
          <div className="feature-icon">💡</div>
          <h3>Hands-on Examples</h3>
          <p>Practice with real code examples and see the results instantly.</p>
        </div>
        <div className="feature">
          <div className="feature-icon">🚀</div>
          <h3>Stay Updated</h3>
          <p>Learn the latest technologies and industry best practices.</p>
        </div>
      </section>
    </div>
  );
};

export default Home;
